/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".small[_ngcontent-%COMP%]{font-size:12px!important}.title[_ngcontent-%COMP%]{font-weight:600!important}"];
export { styles as styles };
